import { Expression } from './Expression.js';
export class OperationDefExpression extends Expression {
    constructor(name, paramNames, inContextDef) {
        super();
        this.name = name;
        this.paramNames = paramNames;
        this.inContextDef = inContextDef;
    }
    evaluate(visitor, localVariables) {
        const object = visitor.getObjectToEvaluate();
        if (object) {
            object[this.name] = (...params) => {
                let operationParams = {};
                if (this.paramNames) {
                    this.paramNames.forEach((v, i) => operationParams[v] = params[i]);
                }
                const locals = Object.assign(Object.assign({}, localVariables), operationParams);
                return this.inContextDef.evaluate(visitor, locals);
            };
        }
        else {
            console.warn('Cannot def operation');
        }
    }
}
//# sourceMappingURL=OperationDefExpression.js.map